import {
  ModalActionDef,
  ModalDefine,
  ModalStatus
} from '@/libs/formHelper/modalForm/type'
import { Donation } from '@/api/donation/Donation'
import StoreService from '@/service/StoreService'

export default function getModalDefine (view: any): ModalDefine<Donation> {
  const items = [
    {
      title: '预览图',
      type: {
        module: 'imageUrl',
        borderRadius: 0
      },
      required: true,
      key: 'imageUrl'
    },
    {
      title: '项目名称',
      col: { span: 12 },
      required: true,
      key: 'name',
      type: {
        module: 'text',
        maxlength: 10
      }
    },
    {
      title: '项目说明',
      col: { span: 24 },
      required: true,
      key: 'effect',
      type: {
        module: 'textarea',
        limit: 200
      }
    },
    {
      title: '村庄',
      col: { span: 12 },
      required: true,
      key: 'villageId',
      slot: 'villageId',
      show: () => StoreService.getTypeSync() === 1
    }
  ]

  const actions: ModalActionDef<Donation>[] = [
    {
      key: 'create',
      title: '创建',
      type: 'submit',
      button: 'success',
      actionClose: true,
      modalStatus: ModalStatus.ADD,
      onClick: (item: Donation) => {
        return view.onInsertItem(item)
      }
    },
    {
      key: 'modi',
      title: '保存',
      type: 'submit',
      button: 'success',
      actionClose: true,
      modalStatus: ModalStatus.MODI,
      onClick: (item: Donation) => {
        return view.onUpdateItem(item)
      }
    }
  ]

  return {
    items,
    actions
  }
}
